"use strict";

const BC_Command = function (EWS) {
    this.EWS = EWS;
    this.Commands = [];
    this.Containers = [];
    this.Menus = [];
    this.Section = document.createElement("section");

    document.body.appendChild(this.Section);

    this.Section.addEventListener("click", (event) => {
        event.stopPropagation();
    });

    const me = this;

    this.AddMenu("BC_EWS_UserMenu", function createDialog(control, name, menu, callback) {
        // Task 748465: Make ECP header mobile friendly
        const myRequest = new ECP.EC_Request("UserMenu");

        myRequest.SetReturnType(ECP.EC_ReturnType.Text);
        // Task 1053868: Update site header and menu to support Offline mode for the mobile frame
        if (EC_Fmt.GetPageParameter("DashboardID")) {
            myRequest.AddRequestVariable("DashboardID", EC_Fmt.GetPageParameter("DashboardID"));
        }

        if (EC_Fmt.GetPageParameter("DashboardVersionID")) {
            myRequest.AddRequestVariable("DashboardVersionID", EC_Fmt.GetPageParameter("DashboardVersionID"));
        }

        myRequest.Submit().then((result) => {
            menu.innerHTML = result;

            menu.addEventListener("click", (event) => {
                const target = event.target.closest(".ews-menu-item");

                if (target) {
                    const action = target.getAttribute("action");

                    EWS.Command.HideAllMenus();

                    if (!EC_Fmt.isNull(action)) {
                        // eslint-disable-next-line no-eval
                        eval(action);
                    }
                }
            });

            // Task 748465: Make ECP header mobile friendly
            const LeftMenu = document.getElementById("Menu");
            const EditDashboardBtn = menu.querySelector("#ActionButtonEditDashboard");
            const selectedDashboard = LeftMenu.querySelector(".MainMenuItemHighlight,.MainMenuPrimaryHighlight");

            if (EditDashboardBtn) {
                const dashboardId = EC_Fmt.GetPageParameter("DashboardID");
                if (!dashboardId || !selectedDashboard || !selectedDashboard.getAttribute("dashboardEditIDArr") || !selectedDashboard.getAttribute("dashboardEditIDArr").includes(dashboardId)) {
                    EditDashboardBtn.classList.add("disabled");
                    EditDashboardBtn.parentElement.setAttribute("title", "Edit Dashboard - You must be the owner of the dashboard, or have Shared Dashboard Edit permission");
                    EditDashboardBtn.removeAttribute("href");
                } else {
                    EditDashboardBtn.href = `Home?DashboardEdit=true&DashboardID=${dashboardId}`;
                }
            }

            const SwitchVersionTypeContent = menu.querySelector("div[name='SwitchVersionType']");
            if (SwitchVersionTypeContent && window.CreateSwitchDashboardVersionTypeButton) {
                CreateSwitchDashboardVersionTypeButton(SwitchVersionTypeContent, true);
            }

            SetRenderTime();
            callback(control, menu);
        });
    }, function openDialog(control, name, menu, newDialog) {
        if (window.Settings.EnableBeta) {
            menu.querySelector(".ews-menu-item[name='BetaFeedbackMenuItem']").style.display = "flex";
        }
        menu.style.display = "flex";
    });

    this.AddMenu("BC_EWS_Status", function createDialog(control, name, menu, callback) {
        EWS.VerifySession(() => {
            fetch("api?APICommand=SalesComm_VoiceControls_StatusMenu", {
                credentials: "same-origin"
            }).then(response => response.text()).then((result) => {
                menu.innerHTML = result;

                menu.addEventListener("click", (event) => {
                    const target = event.target.closest(".ews-menu-item");

                    if (target) {
                        const action = target.getAttribute("action");

                        EWS.Command.HideAllMenus();

                        if (!EC_Fmt.isNull(action)) {
                            // eslint-disable-next-line no-eval
                            eval(action);
                        }
                    }
                });

                callback(control, menu);
            });
        });
    }, function openDialog(control, name, menu, newDialog) {
        // task 455042
        ECP.Dialog.ShowLoading(undefined, ".current-status");

        fetch("api?APICommand=SalesComm_VoiceControls_GetCurrentStatus", {
            credentials: "same-origin"
        }).then(response => response.json()).then((result) => {
            const currentStatus = document.querySelector(".current-status .ews-menu-label");

            if (currentStatus) {
                currentStatus.innerHTML = `Current Status: ${result.status}`;
            }

            ECP.Dialog.HideLoading();
        });
    });

    this.AddMenu("BC_EWS_Remind", function createDialog(control, name, menu, callback) {
        EWS.VerifySession(() => {
            const dateTimeNow = EC_Fmt.DateTimeParseFormat(EC_Fmt.ScreenFmt(new Date(), ECP.DataType._DateTime));
            menu.innerHTML = `<div style="min-height:24px;position:relative;font-size:10pt;color:#000;cursor:pointer;padding:8px 15px 0 15px">`
                + `<div class=ews-menu-label><b>Remind Me</b>`
                + `<div class=tip-container>`
                + ` <span class=ews-icon-info style=font-size:12pt></span>`
                + ` <span class=tip-description style=top:20px;right:0>`
                + ` <b>Tip:</b>`
                + ` <br>Set a date and time in the dialog`
                + ` <br>below and the Remind Me`
                + ` <br>feature will send you an eChat`
                + ` <br>at that time with a link that`
                + ` <br>takes you back to the page you are on right now.`
                + ` </span>`
                + `</div>`
                + `</div>`
                + `</div>`
                + `<div style="min-height:24px;position:relative;font-size:10pt;color:#666;cursor:pointer;padding:0 15px">`
                + ` <input type=Text name=remind title="Remind Me"placeholder="Reminder Message Text"style="width:190px;border:1px #ccc solid"id=remind>`
                + `</div>`
                + `<div style="min-height:24px;position:relative;font-size:10pt;color:#000;cursor:pointer;padding:8px 15px 0 15px">`
                + ` <div class=ews-menu-label><b>Reminder Date/Time</b></div>`
                + `</div>`
                + `<div style="min-height:24px;position:relative;font-size:10pt;color:#666;cursor:pointer;padding:0 15px">`
                + ` ${ECP.HTML.DateTimeInput("myDateTime", "DateTimeField", true, dateTimeNow, "Current Date Time", 1, 180, true, dateTimeNow)}`
                + `</div>`
                + `<div style="min-height:24px;position:relative;font-size:10pt;color:#666;cursor:pointer;margin:8px;padding:0 23%">`
                + ` ${ECP.HTML.Button("SaveChange", "Set Reminder", "", "", "", "ActionButtonAttention")}`
                + `</div>`;

            menu.querySelector("#ActionButtonSaveChange").addEventListener("click", async () => {
                ECP.Dialog.ShowLoading();

                const date = document.getElementById("DateTimeField").value;
                const title = document.getElementById("remind").value;
                if (!date || !title) {
                    ECP.Dialog.HideLoading();
                    ECP.Dialog.Alert("Please input information.");
                    return;
                }

                const delayRequest = new ECP.EC_Request("SendRemindMeEChatMessage");

                delayRequest.AddRequestVariable("DelayedSendTime", EC_Fmt.DateTimeParseFormat(date), ECP.EC_Verb.Post);
                delayRequest.AddRequestVariable("Title", title, ECP.EC_Verb.Post);
                delayRequest.AddRequestVariable("Url", window.location.href, ECP.EC_Verb.Post);
                const message = await delayRequest.Submit();
                if (message.State === "Success") {
                    // Task 1024699: Remind Me: Use Snackbar notification instead of pop-up after scheduling a reminder
                    ECP.HTML.Snackbar("Remind Me Event has been created.", "Success");
                    document.getElementById("ews-BC_EWS_Remind-menu").style.display = "none";
                } else {
                    ECP.HTML.Snackbar(message.errors[0].detail, "Error");
                }
                ECP.Dialog.HideLoading();
            });
            callback(control, menu);
        });
    }, function openDialog(control, name, menu, newDialog) {
        menu.classList.remove("ews-menu");
        menu.classList.add("ColumnMenu");
        menu.classList.add("Hideable");
        menu.style.borderRadius = "6px";
        ECP.Dialog.ShowLoading(undefined, ".current-status");

        ECP.Dialog.HideLoading();
    });

    document.body.addEventListener("click", () => {
        me.HideAllMenus(true);

        const userMenuTrigger = document.querySelector("#Header .LabelButton[name=UserMenu]");
        if (userMenuTrigger) {
            const headerArrowUpIcon = userMenuTrigger.querySelector(".arrowup");
            if (headerArrowUpIcon) {
                headerArrowUpIcon.classList.remove("arrowup");
            }
        }
    });

    EWS.TipsPosition(document);

    me.UniversalSearch = document.getElementById("ews-UnifiedSearch-input");
    if (me.UniversalSearch) {
        me.UniversalSearch.addEventListener("click", () => {
            EWS.VerifySession();
        });
    }
};

BC_Command.prototype.Add = function (name, execute) {
    this.Commands[name] = {
        execute
    };
};

BC_Command.prototype.AddMenu = function (name, create, open) {
    this.Menus[name] = {
        create,
        open
    };
};

BC_Command.prototype.Click = function (trigger) {
    this.Execute(trigger.getAttribute("command"), this.ParseArguments(trigger));
};

BC_Command.prototype.CreateMenu = function (name, menuObj, callback) {
    if (!document.getElementById(`ews-${name}-menu`)) {
        let className = "ews-menu";

        if (EC_Fmt.isMobile) {
            className += " ews-menu-mobile";
        }

        if (menuObj.keepOpen) {
            className += " ews-menu-keep-open";
        }

        let style = "";

        if (!EC_Fmt.isMobile && !EC_Fmt.isNull(menuObj.width)) {
            if (style !== "") {
                style += " ";
            }

            style += `width:${menuObj.width}px;`;
        }

        if (!EC_Fmt.isNull(menuObj.zIndex)) {
            if (style !== "") {
                style += " ";
            }

            style += `z-index:${menuObj.zIndex}`;
        }

        this.Current = EC_Fmt.HtmlStrToElement(`<div id=ews-${name}-menu class="${className}"${style !== "" ? ` style="${style}"` : ""}></div>`);
        this.Section.appendChild(this.Current);

        if (this.Menus[name].create) {
            this.Menus[name].create(this, name, this.Current, (control, menu) => {
                callback(control, menu);
            });
        }
    } else {
        this.Current = document.getElementById(`ews-${name}-menu`);

        callback(this, this.Current);
    }
};

BC_Command.prototype.Execute = function (name, callback) {
    if (this.Commands[name] && this.Commands[name].execute) {
        this.Commands[name].execute(this, callback);
    }
};

BC_Command.prototype.HideContextMenu = function (name) {
    this.HideMenu(name);
};

BC_Command.prototype.HideMenu = function (name) {
    this.Section.querySelector(`#ews-${name}-menu`).style.display = "none";
};

BC_Command.prototype.HideAllMenus = function (closeKeepOpen) {
    const menus = this.Section.getElementsByClassName("ews-menu");

    for (let i = 0; i < menus.length; i += 1) {
        const menu = menus[i];

        if (closeKeepOpen || !menu.classList.contains("ews-menu-keep-open")) {
            menu.style.display = "none";
        }
    }
    if (EC_Fmt.isMobile) {
        const menuMasks = document.body.getElementsByClassName("user-menu-mask");

        for (let i = 0; i < menuMasks.length; i += 1) {
            menuMasks[i].remove();
        }
    }
};

BC_Command.prototype.PositionMenu = function (name, trigger) {
    const menu = this.Section.querySelector(`#ews-${name}-menu`);

    menu.style.opacity = "0";

    requestAnimationFrame(() => {
        const triggerBottom = trigger.getBoundingClientRect().top + trigger.offsetHeight - 1;

        menu.style.top = `${triggerBottom}px`;
        menu.style.opacity = "1";
    });
};

BC_Command.prototype.ParseArguments = function (trigger) {
    if (trigger) {
        const myArguments = {};
        const args = trigger.getAttribute("args");

        if (args) {
            const data = args.split("&");

            for (let i = 0; i < data.length; i++) {
                const item = data[i].split("=");

                if (item.length > 1) {
                    myArguments[item[0]] = item[1];
                }
            }
        }

        myArguments.trigger = trigger;

        return myArguments;
    }
    return {};
};

BC_Command.prototype.ShowContextMenu = function (name, event, openArgs) {
    this.HideAllMenus();

    this.CreateMenu(name, openArgs, (control, menu) => {
        if (menu) {
            if (control.Menus[name].open) {
                control.Menus[name].open(control, name, menu, openArgs);
            }

            let top = event.pageY;
            let left = event.pageX;

            menu.style.display = "block";
            menu.style.top = `${top}px`;
            menu.style.left = `${left}px`;

            requestAnimationFrame(() => {
                if ((menu.offsetHeight + top) > (window.innerHeight + window.scrollTop)) {
                    top = top - menu.offsetHeight - trigger.offsetHeight;
                }

                if ((menu.offsetWidth + left) > (window.innerWidth + window.scrollLeft)) {
                    left = (left - menu.offsetWidth) + trigger.offsetWidth;
                }

                menu.style.top = `${top}px`;
                menu.style.left = `${left}px`;
            });
        }
    });
};

BC_Command.prototype.ShowMenu = function (name, trigger, openArgs) {
    if (openArgs === undefined) {
        openArgs = {};
    }

    openArgs.trigger = trigger;

    if (openArgs.persistent === undefined) {
        openArgs.persistent = false;
    }

    this.CreateMenu(name, openArgs, (control, menu) => {
        const dropdownIcon = trigger.querySelector(".ews-icon-caretdown");
        if (menu) {
            openArgs.trigger = trigger;

            if (!openArgs.persistent && menu.offsetWidth > 0) {
                control.HideAllMenus();
                if (dropdownIcon) {
                    dropdownIcon.classList.remove("arrowup");
                }
            } else {
                const position = trigger.getBoundingClientRect();

                requestAnimationFrame(() => {
                    menu.style.display = "block";

                    let top = position.top + trigger.offsetHeight;
                    let left = position.left;

                    if (EC_Fmt.isMobile) {
                        top = (position.top + trigger.offsetHeight);
                        left = position.left;
                    }

                    if (!openArgs.persistent) {
                        if ((menu.offsetHeight + top) > window.innerHeight && top > menu.offsetHeight) {
                            top -= menu.offsetHeight;
                        }

                        if ((menu.offsetWidth + left) > window.innerWidth && left > (menu.offsetWidth - trigger.offsetWidth)) {
                            left = (left - menu.offsetWidth) + trigger.offsetWidth;
                        }
                    }

                    menu.style.top = `${top}px`;
                    menu.style.left = `${left}px`;

                    requestAnimationFrame(() => {
                        const inputTopHeight = trigger.getBoundingClientRect().top;
                        const inputBottomHeight = window.innerHeight - inputTopHeight - trigger.offsetHeight - 5;

                        menu.style.height = "auto";

                        if (inputTopHeight > inputBottomHeight && inputBottomHeight < menu.offsetHeight) {
                            if (inputTopHeight < menu.offsetHeight) {
                                menu.style.height = `${inputTopHeight}px`;

                                top = top - inputTopHeight - trigger.offsetHeight;
                            } else {
                                top -= trigger.offsetHeight;
                            }
                        } else if (inputBottomHeight < menu.offsetHeight) {
                            menu.style.height = `${inputBottomHeight}px`;
                        }

                        if ((menu.offsetWidth + left) > (window.innerWidth + window.scrollLeft)) {
                            left = (left - menu.offsetWidth) + trigger.offsetWidth;
                        }

                        menu.style.top = `${top}px`;
                        menu.style.left = `${left}px`;
                        if (menu.innerHTML !== "" && menu.style.display === "none") {
                            menu.style.display = "block";
                        }

                        if (dropdownIcon) {
                            dropdownIcon.classList.add("arrowup");
                        }
                    });

                    if (control.Menus[name].open) {
                        control.Menus[name].open(control, name, menu, openArgs);
                    }
                });
            }
        }
    });
};

(function (EWS) {
    // eslint-disable-next-line no-shadow
    EWS.Ready((EWS) => {
        EWS.Command = new BC_Command(EWS);
    });
}(EWS));
